import { useContext, createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  // Check for stored token on mount
  useEffect(() => {
    const token = localStorage.getItem("token") || sessionStorage.getItem("token");
    if (token) {
      // Optionally validate token with API
    }
  }, []);

  const loginAction = async (data, rememberMe) => {
    try {
      const response = await fetch(
        process.env.REACT_APP_JERSEYDIRECTORY_API_LoginURL,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({})); // Try to parse JSON, fallback to empty object
        throw new Error(errorData.message || `Invalid credentials (Status: ${response.status})`);
      }

      const res = await response.json();

      if (res.data && res.data.user && res.data.token) {
        setUser(res.data.user);
        if (rememberMe) {
          localStorage.setItem("token", res.data.token);
        } else {
          sessionStorage.setItem("token", res.data.token);
        }
        navigate("/");
        return { success: true };
      }

      throw new Error(res.message || "No user data in response");
    } catch (err) {
      throw new Error(err.message || "Login failed");
    }
  };

  const logOut = () => {
    setUser(null);
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <AuthContext.Provider value={{ user, loginAction, logOut }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};